const API = 'https://api.chucknorris.io/jokes/random';

export function fetchChuckNorrisJokes() {
    let url = API;
    return fetch(url).then((res) => res.json());
}


// WEBPACK FOOTER //
// ./src/component/home/home.service.js